import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedOptions = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <g>
                <path
                    className={styles.cls1}
                    d="M36.04,71.35c-19.48,0-35.33-15.85-35.33-35.33S16.56,0.7,36.04,0.7s35.33,15.85,35.33,35.33
		S55.52,71.35,36.04,71.35z M36.04,4.29c-17.5,0-31.73,14.23-31.73,31.73s14.23,31.73,31.73,31.73s31.73-14.23,31.73-31.73
		S53.53,4.29,36.04,4.29z"
                />
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M49.25,54.01H21.97c-0.29,0-0.53-0.24-0.53-0.53V14.89c0-0.29,0.24-0.53,0.53-0.53h20.5
						c0.14,0,0.28,0.06,0.38,0.16l6.79,6.79c0.1,0.1,0.16,0.23,0.16,0.38v31.8C49.79,53.77,49.55,54.01,49.25,54.01z M22.5,52.95
						h26.22V21.9l-6.48-6.48H22.5V52.95z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M49.25,54.61H21.96c-0.62,0-1.13-0.51-1.13-1.13V14.89c0-0.62,0.51-1.13,1.13-1.13h20.5
						c0.3,0,0.59,0.12,0.8,0.33l6.79,6.79c0.21,0.21,0.33,0.5,0.33,0.8v31.8C50.38,54.1,49.88,54.61,49.25,54.61z M23.1,52.35h25.02
						v-30.2l-6.13-6.13H23.1V52.35z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M49.25,22.21h-6.8c-0.14,0-0.28-0.06-0.38-0.16c-0.1-0.1-0.16-0.24-0.16-0.38l0.01-6.79
						c0-0.22,0.13-0.41,0.33-0.49c0.2-0.08,0.43-0.04,0.58,0.12l6.79,6.79c0.15,0.15,0.2,0.38,0.12,0.58
						C49.66,22.08,49.47,22.21,49.25,22.21z M42.98,21.15h4.98l-4.98-4.98L42.98,21.15z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M49.25,22.81h-6.8c-0.3,0-0.59-0.12-0.8-0.33c-0.21-0.21-0.33-0.5-0.33-0.8l0.01-6.79
						c0-0.46,0.27-0.87,0.7-1.04c0.42-0.18,0.91-0.08,1.23,0.25l6.79,6.79c0.33,0.33,0.42,0.81,0.24,1.23
						C50.12,22.54,49.71,22.81,49.25,22.81z M43.58,20.55h2.94l-2.93-2.93L43.58,20.55z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M45.12,27.53h-12c-0.29,0-0.53-0.24-0.53-0.53c0-0.29,0.24-0.53,0.53-0.53h12c0.29,0,0.53,0.24,0.53,0.53
						C45.65,27.29,45.41,27.53,45.12,27.53z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M45.12,28.13h-12c-0.62,0-1.13-0.51-1.13-1.13c0-0.62,0.51-1.13,1.13-1.13h12c0.62,0,1.13,0.51,1.13,1.13
						C46.25,27.63,45.74,28.13,45.12,28.13z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M45.12,32.32h-12c-0.29,0-0.53-0.24-0.53-0.53c0-0.29,0.24-0.53,0.53-0.53h12c0.29,0,0.53,0.24,0.53,0.53
						C45.65,32.08,45.41,32.32,45.12,32.32z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M45.12,32.92h-12c-0.62,0-1.13-0.51-1.13-1.13c0-0.62,0.51-1.13,1.13-1.13h12c0.62,0,1.13,0.51,1.13,1.13
						C46.25,32.41,45.74,32.92,45.12,32.92z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M45.12,37.11h-12c-0.29,0-0.53-0.24-0.53-0.53s0.24-0.53,0.53-0.53h12c0.29,0,0.53,0.24,0.53,0.53
						S45.41,37.11,45.12,37.11z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M45.12,37.71h-12c-0.62,0-1.13-0.51-1.13-1.13s0.51-1.13,1.13-1.13h12c0.62,0,1.13,0.51,1.13,1.13
						S45.74,37.71,45.12,37.71z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M45.12,41.9h-12c-0.29,0-0.53-0.24-0.53-0.53c0-0.29,0.24-0.53,0.53-0.53h12c0.29,0,0.53,0.24,0.53,0.53
						C45.65,41.66,45.41,41.9,45.12,41.9z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M45.12,42.5h-12c-0.62,0-1.13-0.51-1.13-1.13c0-0.62,0.51-1.13,1.13-1.13h12c0.62,0,1.13,0.51,1.13,1.13
						C46.25,41.99,45.74,42.5,45.12,42.5z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M45.12,46.69h-12c-0.29,0-0.53-0.24-0.53-0.53c0-0.29,0.24-0.53,0.53-0.53h12c0.29,0,0.53,0.24,0.53,0.53
						C45.65,46.45,45.41,46.69,45.12,46.69z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M45.12,47.29h-12c-0.62,0-1.13-0.51-1.13-1.13c0-0.62,0.51-1.13,1.13-1.13h12c0.62,0,1.13,0.51,1.13,1.13
						C46.25,46.78,45.74,47.29,45.12,47.29z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M30.25,32.32h-4.58c-0.29,0-0.53-0.24-0.53-0.53v-4.58c0-0.29,0.24-0.53,0.53-0.53h4.58
						c0.29,0,0.53,0.24,0.53,0.53v4.58C30.78,32.08,30.54,32.32,30.25,32.32z M26.2,31.26h3.51v-3.51H26.2V31.26z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M30.25,32.92h-4.58c-0.62,0-1.13-0.51-1.13-1.13v-4.58c0-0.62,0.51-1.13,1.13-1.13h4.58
						c0.62,0,1.13,0.51,1.13,1.13v4.58C31.38,32.41,30.87,32.92,30.25,32.92z M26.8,30.66h2.31v-2.31H26.8V30.66z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M27.56,38.25c-0.14,0-0.27-0.05-0.38-0.16l-0.55-0.55c-0.21-0.21-0.21-0.54,0-0.75
						c0.21-0.21,0.54-0.21,0.75,0l0.18,0.18l0.97-0.97c0.21-0.21,0.54-0.21,0.75,0c0.21,0.21,0.21,0.54,0,0.75l-1.35,1.35
						C27.83,38.2,27.7,38.25,27.56,38.25z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M27.56,38.85c-0.3,0-0.59-0.12-0.8-0.33l-0.55-0.55c-0.44-0.44-0.44-1.16,0-1.6
						c0.36-0.36,0.89-0.43,1.32-0.21l0.59-0.59c0.21-0.21,0.52-0.28,0.8-0.33c0.3,0,0.59,0.12,0.8,0.33c0.44,0.44,0.44,1.16,0,1.6
						l-1.35,1.35C28.15,38.73,27.86,38.85,27.56,38.85z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M30.25,39.79h-4.58c-0.29,0-0.53-0.24-0.53-0.53v-4.58c0-0.29,0.24-0.53,0.53-0.53h4.58
						c0.29,0,0.53,0.24,0.53,0.53v4.58C30.78,39.55,30.54,39.79,30.25,39.79z M26.2,38.72h3.51v-3.51H26.2V38.72z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M30.25,40.39h-4.58c-0.62,0-1.13-0.51-1.13-1.13v-4.58c0-0.62,0.51-1.13,1.13-1.13h4.58
						c0.62,0,1.13,0.51,1.13,1.13v4.58C31.38,39.88,30.87,40.39,30.25,40.39z M26.8,38.12h2.31v-2.31H26.8V38.12z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M30.25,47.26h-4.58c-0.29,0-0.53-0.24-0.53-0.53v-4.58c0-0.29,0.24-0.53,0.53-0.53h4.58
						c0.29,0,0.53,0.24,0.53,0.53v4.58C30.78,47.02,30.54,47.26,30.25,47.26z M26.2,46.19h3.51v-3.51H26.2V46.19z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M30.25,47.85h-4.58c-0.62,0-1.13-0.51-1.13-1.13v-4.58c0-0.62,0.51-1.13,1.13-1.13h4.58
						c0.62,0,1.13,0.51,1.13,1.13v4.58C31.38,47.35,30.87,47.85,30.25,47.85z M26.8,45.59h2.31v-2.31H26.8V45.59z"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedOptions;
